// @generated by protoc-gen-es v2.10.2
// @generated from file ltd/v1/ws.proto (package ltd.v1, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file ltd/v1/ws.proto.
 */
export const file_ltd_v1_ws =
  /*@__PURE__*/
  fileDesc(
    'Cg9sdGQvdjEvd3MucHJvdG8SBmx0ZC52MSI8CgRJdGVtEgoKAmlkGAEgASgJEg0KBXZhbHVlGAIgASgJEgwKBHRvZG8YAyABKAgSCwoDZG90GAQgASgNIiQKBUl0ZW1zEhsKBWl0ZW1zGAEgAygLMgwubHRkLnYxLkl0ZW0iFwoGQ3JlYXRlEg0KBXZhbHVlGAEgASgJIgYKBFJlYWQiPgoGVXBkYXRlEgoKAmlkGAEgASgJEg0KBXZhbHVlGAIgASgJEgwKBHRvZG8YAyABKAgSCwoDZG90GAQgASgNIggKBkRlbGV0ZSI0CgRTb3J0Eg4KBnRhcmdldBgBIAEoCRIOCgZpbnNlcnQYAiABKAkSDAoEbGFzdBgDIAEoCCK2AQoHUmVxdWVzdBIgCgZjcmVhdGUYASABKAsyDi5sdGQudjEuQ3JlYXRlSAASHAoEcmVhZBgCIAEoCzIMLmx0ZC52MS5SZWFkSAASIAoGdXBkYXRlGAMgASgLMg4ubHRkLnYxLlVwZGF0ZUgAEiAKBmRlbGV0ZRgEIAEoCzIOLmx0ZC52MS5EZWxldGVIABIcCgRzb3J0GAUgASgLMgwubHRkLnYxLlNvcnRIAEIJCgdjb21tYW5kQk4KCmNvbS5sdGQudjFCB1dzUHJvdG9QAaICA0xYWKoCBkx0ZC5WMcoCBkx0ZFxWMeICEkx0ZFxWMVxHUEJNZXRhZGF0YeoCB0x0ZDo6VjFiBnByb3RvMw',
  );

/**
 * Describes the message ltd.v1.Item.
 * Use `create(ItemSchema)` to create a new message.
 */
export const ItemSchema = /*@__PURE__*/ messageDesc(file_ltd_v1_ws, 0);

/**
 * Describes the message ltd.v1.Items.
 * Use `create(ItemsSchema)` to create a new message.
 */
export const ItemsSchema = /*@__PURE__*/ messageDesc(file_ltd_v1_ws, 1);

/**
 * Describes the message ltd.v1.Create.
 * Use `create(CreateSchema)` to create a new message.
 */
export const CreateSchema = /*@__PURE__*/ messageDesc(file_ltd_v1_ws, 2);

/**
 * Describes the message ltd.v1.Read.
 * Use `create(ReadSchema)` to create a new message.
 */
export const ReadSchema = /*@__PURE__*/ messageDesc(file_ltd_v1_ws, 3);

/**
 * Describes the message ltd.v1.Update.
 * Use `create(UpdateSchema)` to create a new message.
 */
export const UpdateSchema = /*@__PURE__*/ messageDesc(file_ltd_v1_ws, 4);

/**
 * Describes the message ltd.v1.Delete.
 * Use `create(DeleteSchema)` to create a new message.
 */
export const DeleteSchema = /*@__PURE__*/ messageDesc(file_ltd_v1_ws, 5);

/**
 * Describes the message ltd.v1.Sort.
 * Use `create(SortSchema)` to create a new message.
 */
export const SortSchema = /*@__PURE__*/ messageDesc(file_ltd_v1_ws, 6);

/**
 * Describes the message ltd.v1.Request.
 * Use `create(RequestSchema)` to create a new message.
 */
export const RequestSchema = /*@__PURE__*/ messageDesc(file_ltd_v1_ws, 7);
